import {
  FilterControl,
  FilterControlProps,
} from "@/containers/QueryBuilder/FilterControl";
import { useTags } from "@/contexts/TagContext";

type AutoTagQueryProps = Omit<
  FilterControlProps,
  "options" | "canCreateNewOptions"
>;

const AutoTagQuery: React.FC<AutoTagQueryProps> = (props) => {
  const { organizationTags } = useTags();

  const optionValues = (organizationTags?.map((k) => k.name) || []).filter(
    (t) => t !== "favorited"
  );

  const options = [
    ...(props.values || []).filter((v) => !optionValues.includes(v)),
    ...optionValues,
  ];

  return (
    <FilterControl
      {...props}
      canCreateNewOptions
      options={options}
      filterName=""
    />
  );
};

export default AutoTagQuery;
